import { formatPagination } from '../../utils/pagination';

class SupportDelegate {
    setTicketsLoading(loading) {
        this.setState({ ticketsLoading: loading });
    }

    setPerPage(value, callback) {
        this.setState({ listPageSize: value }, callback);
    }

    setPagination(items, pageinfo) {
        const tickets = items || [];
        const pageInfo = pageinfo || {};
        const pagination = pageInfo ? formatPagination(pageInfo) : null;
        this.setState({ tickets, pageInfo, pagination, ticketsLoaded: true });
    }

    /** A failed fetch still counts as "asked", so switching tabs does not retry silently. */
    setTicketsLoaded() {
        this.setState({ ticketsLoaded: true });
    }

    setCreateModalOpen(open) {
        this.setState({ createModalOpen: open });
    }

    setCreateSubmitting(value) {
        this.setState({ createSubmitting: value });
    }

    setNewTicketSubject(value) {
        this.setState({ newTicketSubject: value });
    }

    setNewTicketBody(value) {
        this.setState({ newTicketBody: value });
    }

    setNewTicketAttachments(value) {
        this.setState({ newTicketAttachments: value });
    }

    setNewTicketCategory(value) {
        this.setState({ newTicketCategory: value });
    }

    setNewTicketPriority(value) {
        this.setState({ newTicketPriority: value });
    }

    handleOpenCreateModal() {
        this.setState({
            createModalOpen: true,
            newTicketSubject: '',
            newTicketBody: '',
            newTicketAttachments: [],
            newTicketCategory: null,
            newTicketPriority: null
        });
    }

    handleCloseCreateModal() {
        const { newTicketAttachments } = this.state;
        for (const att of newTicketAttachments) {
            if (att.url?.startsWith('blob:')) URL.revokeObjectURL(att.url);
        }
        this.setState({ createModalOpen: false });
    }

    setStatusTab(value, callback) {
        this.setState({ statusTab: value }, callback);
    }
}

export default SupportDelegate;
